<template>
  <div>

<div class="columns is-gapless is-multiline">

<div class="column is-1 is-size-7 has-text-weight-bold has-text-right mt-2">SESS-ANN&nbsp;&nbsp;</div>
<div class="column is-1">
    <div class="select is-fullwidth">
        <select v-model="grp_sess" @change="reload()">
            <option>H</option> <option>E</option>  <option>A</option>
        </select>
    </div>
</div>


<div class="column is-1">
    <div class="select is-fullwidth">
        <select v-model="grp_ann" @change="reload()">
            <option>17</option><option>18</option><option>19</option> <option>20</option><option>21</option><option>22</option>
        </select>
    </div>
</div>

</div>
<!-- END MAIN COLUMN  -->

  </div>
</template>

<script>

export default {
  name: 'AdminStats',
  components: {},


    data() {
        return {
            grp_sess:'',
            grp_ann:'',


        }
    },





created () {
    
},

methods: {

reload:function() {


var sql = `SELECT COUNT(MyMEQ_STUDENT.student_ID) AS cnt, myMEQ_STUDENT_TRANSMISSION.useLang
FROM MyMEQ_STUDENT INNER JOIN
MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN
MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN
myMEQ_STUDENT_TRANSMISSION ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TRANSMISSION.student_ID
WHERE (MyMEQ_GROUP.group_SESS = 'A') AND (MyMEQ_GROUP.group_ANN = '20')
GROUP BY myMEQ_STUDENT_TRANSMISSION.useLang`

var sql = `SELECT MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_GROUP.group_CODE, MyMEQ_COUR.cour_CODE, MyMEQ_COURSESTUDENT.student_ID, 
MyMEQ_GROUP.group_ID, MyMEQ_COURSESTUDENT.cs_REMARK
FROM  MyMEQ_COURSESTUDENT INNER JOIN
MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN
MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
WHERE (MyMEQ_GROUP.group_SESS = 'A') AND (MyMEQ_GROUP.group_ANN = '20')`



},



// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},



}



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
